import styled from 'styled-components'

export const JobsFiltersWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray};
  padding: 2rem 0;
  margin-bottom: 2rem;
`
